import React, { Component } from 'react'
import { Table, Spin } from 'antd'
import moment from 'moment'

class ListItems extends Component {
  getColumns = () => {
    return [
      {
        title: 'ID',
        dataIndex: 'id',
        sorter: (a, b) => a.id - b.id
      },
      {
        title: 'Name',
        dataIndex: 'name',
        sorter: (a, b) => a.name.localeCompare(b.name)
      },
      {
        title: 'Description',
        dataIndex: 'description'
      },
      {
        title: 'Job ID',
        dataIndex: 'job_id'
      },
      {
        title: 'Job Name',
        dataIndex: 'job_name',
        sorter: (a, b) => a.job_name.localeCompare(b.job_name)
      },
      {
        title: 'Company',
        dataIndex: 'organization_name',
        sorter: (a, b) => a.organization_name.localeCompare(b.organization_name)
      },
      {
        title: 'Created Date',
        dataIndex: 'created_date',
        sorter: (a, b) => moment(a.created_date).isSameOrBefore(b.created_date)
      }
    ]
  }

  getData = () => {
    const { fullReport } = this.props

    return fullReport.map((item, index) => {
      item.created_date = moment(new Date(item.created_date)).format('YYYY-MM-DD')
      item.key = item.id
      return item
    })
  }

  render() {
    const { loadingFullReport, fullReport } = this.props
    return (
      <div>
        {loadingFullReport && <Spin />}
        {!loadingFullReport &&
          fullReport && (
            <div>
              <div style={{ marginTop: 20 }} className="row">
                <div className="col-12">
                  <h5>Tickets</h5>
                </div>
              </div>
              <Table
                pagination={false}
                columns={this.getColumns()}
                dataSource={this.getData()}
                size="small"
                style={{ backgroundColor: 'white' }}
              />
            </div>
          )}
      </div>
    )
  }
}

export default ListItems



// WEBPACK FOOTER //
// ./src/components/reports/maintenance_dob/tickets/ListItem.js